"use client"

import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"

export function PostHogIdentify({ user }) {
  const posthog = usePostHog()

  useEffect(() => {
    if (posthog && user) {
      posthog.identify(user.id, {
        email: user.email,
      })

      // Google Ads signup conversion - only for new users (created in last 2 min)
      if (user.createdAt && window.gtag) {
        const ageMs = Date.now() - new Date(user.createdAt).getTime()
        if (ageMs < 120000) {
          window.gtag("event", "conversion", {
            send_to: "AW-935494349/OMVaCM_wjcYbEM2Fir4D",
            value: 1.0,
            currency: "USD",
          })
        }
      }
    } else if (posthog && !user) {
      posthog.reset()
    }
  }, [posthog, user])

  return null
}
